import {
  Backdrop,
  Box,
  CircularProgress,
  Grid2,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Email, QuestionAnswer } from "@mui/icons-material";
import axiosInstance from "../../../utils/config/config";
import { useSelector } from "react-redux";
import CommentsModal from "../../../components/Modals/CommentsModal";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../../components/Common/CustomSnackbar";

const SetUpSession = ({ filterResults }) => {
  const theme = useTheme();
  const { userData } = useSelector((state) => state.user);
  const [allSessions, setAllSessions] = useState([]);

  const [commentsModal, setCommentsModal] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [loading, setloading] = useState(false);

  const [success, setsuccess] = useState(false);
  const [errorState, seterrorState] = useState({
    error: false,
    message: "",
  });

  const GetAllSessions = async () => {
    try {
      setloading(true);

      const response = await axiosInstance.get("sessionexchange/getAll");

      if (response.status === 200) {
        setAllSessions(response.data?.sessionExchanges);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    GetAllSessions();
  }, []);

  const filteredSessions = filterResults
    ? allSessions?.filter((item) => item?.userId === userData?.id)
    : allSessions;

  console.log("Filtered Sessions:", filteredSessions);

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid2 container spacing={2} sx={{ mt: 4 }}>
        {filteredSessions?.map((item) => (
          <Grid2 item size={{ xs: 12 }} sx={{ mb: 3 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: `1px solid #fff`,
              }}
            >
              <Stack
                direction="row"
                sx={{
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "'Gotham', sans-serif",
                    fontSize: "24px",
                    lineHeight: "30px",
                    color: theme.palette.text.primary,
                  }}
                >
                  {item?.name}
                </Typography>
                {item?.gender && (
                  <Typography
                    sx={{
                      fontFamily: "'Gotham', sans-serif",
                      fontSize: "14px",
                      lineHeight: "18px",
                      color: theme.palette.text.primary,
                    }}
                  >
                    {`( ${item?.gender} )`}
                  </Typography>
                )}
                <Typography
                  sx={{
                    fontFamily: "'Gotham', sans-serif",
                    fontSize: "14px",
                    lineHeight: "18px",
                    color: theme.palette.text.primary,
                  }}
                >
                  {"( " + item?.numOfTrainings + " TRAINING HOURS)"}
                </Typography>
              </Stack>
              <Stack direction="row" gap={2}>
                <IconButton
                  onClick={() => {
                    setCommentsModal(true);
                    setSessionId(item?.id);
                  }}
                >
                  <QuestionAnswer sx={{ color: theme.palette.text.primary }} />
                </IconButton>
                <IconButton
                  onClick={() => {
                    window.open(
                      `mailto:${item?.user?.email}?subject=Session%20Exchange%20Request&body=Hello%20${item?.user?.firstName}`
                    );
                  }}
                >
                  <Email sx={{ color: theme.palette.text.primary }} />
                </IconButton>
                {/* {item?.userId === userData?.id && (
                  <IconButton>
                    <Delete sx={{ color: theme.palette.text.primary }} />
                  </IconButton>
                )} */}
              </Stack>
            </Box>
            <Box sx={{ mt: 2 }}>
              {(item?.lookingForGender ||
                item?.lookingForStatus ||
                item?.lookingForNumOfTrainings) && (
                <Typography
                  sx={{
                    color: theme.palette.text.primary,
                    fontFamily: "'Gotham', sans-serif",
                    fontSize: "16px",
                    mb: 1,
                  }}
                >
                  Looking for:
                </Typography>
              )}

              {item?.lookingForGender && (
                <Typography
                  sx={{
                    fontFamily: "'Gotham', sans-serif",
                    fontSize: "14px",
                    lineHeight: "18px",
                    color: theme.palette.text.primary,
                  }}
                >
                  Gender:{"  "}
                  <Typography
                    component={"span"}
                    sx={{ fontFamily: "'Gotham', sans-serif" }}
                  >
                    {item?.lookingForGender?.map((item) => item + ", ")}
                  </Typography>
                </Typography>
              )}
              {item?.lookingForStatus && (
                <Typography
                  sx={{
                    fontFamily: "'Gotham', sans-serif",
                    fontSize: "14px",
                    lineHeight: "18px",
                    color: theme.palette.text.primary,
                  }}
                >
                  Educational Status:{"  "}
                  <Typography
                    component={"span"}
                    sx={{ fontFamily: "'Gotham', sans-serif" }}
                  >
                    {item?.lookingForStatus}
                  </Typography>
                </Typography>
              )}
              {item?.lookingForNumOfTrainings !== null &&
                item?.lookingForNumOfTrainings !== undefined && (
                  <Typography
                    sx={{
                      fontFamily: "'Gotham', sans-serif",
                      fontSize: "14px",
                      lineHeight: "18px",
                      color: theme.palette.text.primary,
                    }}
                  >
                    Number of Training:{"  "}
                    <Typography
                      component={"span"}
                      sx={{ fontFamily: "'Gotham', sans-serif" }}
                    >
                      {item?.lookingForNumOfTrainings}
                    </Typography>
                  </Typography>
                )}

              <Typography
                sx={{
                  color: theme.palette.text.primary,
                  fontFamily: "'Gotham', sans-serif",
                  fontSize: "16px",
                  mb: 1,
                  mt: 2,
                }}
              >
                Reason for seeking a hypnotherapy session:
              </Typography>
              <Typography
                sx={{
                  fontFamily: "'Quicksand', sans-serif",
                  fontSize: "16px",
                  color: theme.palette.text.primary,
                }}
              >
                {item?.description}
              </Typography>
            </Box>
          </Grid2>
        ))}
      </Grid2>

      {/* <Box sx={{ mt: 4 }}>
        <CustomInput
          placeholder="Enter your comments"
          value={comment}
          setValue={setComment}
          Icon={Send}
          rightIcon
          bR={"1px"}
          width={"100%"}
        />
      </Box> */}

      <CommentsModal
        open={commentsModal}
        handleClose={() => setCommentsModal(false)}
        sessionId={sessionId}
        setloading={setloading}
        setsuccess={setsuccess}
        seterrorState={seterrorState}
      />
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => seterrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setsuccess(false)}
        text={"Comment added successfully"}
      />
    </Box>
  );
};

export default SetUpSession;
